import type { AdvancedSettingsForm } from './ReportStatusRow'

/**
 *
 * @deprecated We are changing everything to be edited inline so once that flag is on this file can be deleted
 *
 * in case user has an advanced setting open but navigates to a different tab.
 * when navigating back the editor should be set back to the same state
 * only doing this to avoid complexity going back & forth elm as this is not a showstopper feature just some qol improvement */
export function AdvancedSettingsCache(uuid: string) {
    const FORM_LOCAL_STORAGE_KEY = 'reportStatusFlowAdvancedSettingsFormInstance-' + uuid

    return {
        getCachedFormValues: (): AdvancedSettingsForm => {
            const form = sessionStorage.getItem(FORM_LOCAL_STORAGE_KEY)
            return form ? JSON.parse(form) : null
        },
        cacheFormValues: (value: AdvancedSettingsForm) => {
            sessionStorage.setItem(FORM_LOCAL_STORAGE_KEY, JSON.stringify(value))
        },
        clearCachedFormValues: () => {
            sessionStorage.removeItem(FORM_LOCAL_STORAGE_KEY)
        },
    }
}
